<template>
    <div class="pt-3 pl-5 pr-5">
        <div class="flex justify-between items-center">
            <h1 class="title">Activity Risk</h1>
            <div class="flex items-center">
                <!-- <div class="noteam text-center">
                    <button class="btnprimary mr-2" @click="showPopUp()">Add</button>
                </div> -->
                <div>
                    <div @click="filterOpen">
                        <button class="flex" :class="tableRow.length == 0 ? 'btndisabled pointer-events-none' : 'filterButton'">
                            <img v-if="tableRow.length == 0" src="@/assets/filterIcon_Disabled.svg" class="filterIcon"/>
                            <img v-else src="@/assets/filter.svg" class="filterIcon" />
                            Filters
                        </button>
                    </div>
                </div>
            </div>
        </div>

        <div class="mt-3 text-xs">
            Identify, manage, and monitor risks in key activities or processes performed by various teams across the organization.
        </div>

        <div>
            <newTable :tableRowData="tableRow" :headersData="headers" :openPopup="false" :navigate="true" :loadData="dataLoading"></newTable>
            <div v-if="toolTipActive">
                <tool-tip :tipText="toolTipText"></tool-tip>
            </div>
        </div>


    </div>
</template>
<style scoped>
.invalid-multiselect {
    border: 1px solid red !important;
}
.v-select-list li {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
</style>
<script lang="ts">
import { defineComponent } from 'vue';
import { required, maxLength, minLength, email, helpers, requiredIf } from '@vuelidate/validators';
import useVuelidate from '@vuelidate/core';
import { emitter, toast } from '../../main';
const numeric = helpers.regex(/^\(?([0-9]{3})\)?[-. ]?([0-9]{3})[-. ]?([0-9]{4})$/i);
import popup from '@/components/popup.vue';
import toolTip from '@/components/toolTip.vue';
import { mapGetters } from 'vuex';
import _ from 'lodash';
import moment from 'moment';
import newTable from '@/components/newTable.vue';

export default defineComponent({
    data(): any {
        return {
            v$: useVuelidate(),
            permissions: [],
            tableRow: [],
            showFilters: false,
            dummyObj: {},
            headers: ['_id', 'entityId', 'Activity', 'Team','Location', 'Owner','criticality','risks'],
            businessProcess: {
                criticality: '',
                businessProcessName: '',
                ownerType: '',
                name: '',
                department: '',
                role: '',
                emailAddress: '',
                phoneNumber: '',
                systems: [],
                description:'',
                // informations: []
            },
            businessProcessList: [],
            systems: [],
            users: [],
            optionsUserArray: [],
            tenantsSelect: [],
            tenants: [],
            savedInformationSets: [],
            teams: [],
            Entities:[],
            popUpOpen: false,
            ownerTypeValues: [
                {
                    id: 1,
                    value: 'Primary'
                },
                {
                    id: 2,
                    value: 'Secondary'
                }
            ],
            departmentList: [],
            editpop: false,

            toolTipActive : false,
            toolTipText : '',
            dataLoading:true,
        };
    },
    components: {
        newTable,
        popup,
        toolTip
    },
    computed: {
        ...mapGetters({ dbProcessCriticality:'dbProcessCriticality' }),
        ...mapGetters({ userInfo: 'userInfo',tenentsInfo:'tenentsInfo' }),
    },
    methods: {
        filterOpen() {
            this.showFilters = !this.showFilters;
            emitter.emit('visible', this.showFilters);
        },
        getUserDetails(nameId:any){
            let mainUser = this.users.find((user:any)=>{return user._id==nameId})
            // this.businessProcess.emailAddress = mainUser.email;
            this.businessProcess.role = mainUser.jobTitle;
        },
        async getAllUsers() {
            await this.$http.get(`${process.env.VUE_APP_ORG_API}/users/getAll`).then((res: any) => {
                this.users = res.data;
            });
            for (var i = 0; i < this.users.length; i++) {
                this.optionsUserArray.push({ label: this.users[i].name, value: this.users[i]._id });
            }
        },
        async getSystems() {
            let entityId = '20005';
            await this.$http.get(`${process.env.VUE_APP_ORG_API}/api/org/getall/${entityId}`).then((result: any) => {
                this.systems = result.data;
                this.dummySystems = result.data;
                this.systems = this.systems.map((sys: any) => {
                    return { value: sys._id, label: sys.systemName };
                });
            });
        },
        async getSingleEntity(){
			await this.$http.get(`${process.env.VUE_APP_ORG_API}/api/org/businessEntities/getall`).then((res: any) => {
				this.organizationList = res.data;
			});
			for(let i=0;i<this.organizationList.length;i++) {
				this.Entities.push({label:this.organizationList[i].entityDisplayName,value:this.organizationList[i]._id,entityType:this.organizationList[i].entityType})
			}
			// this.$store.dispatch('updateDotsLoading', false);
		},
        async getAllTenants() {
            // await this.$http.get(`${process.env.VUE_APP_AUTH_API}/tenants/getAll`).then((res: any) => {
                this.tenentsInfo.map((org: any) => {
                    const obj = { id: org._id, name: org.organizationName };
                    this.tenants.push(obj);
                    const object = { value: org._id, label: org.organizationName };
                    this.tenantsSelect.push(object);
                });
            // });
        },
        async getInformationSets() {
            this.savedInformationSets = [];
            await this.$http.get(`${process.env.VUE_APP_ORG_API}/api/root/information/getall`).then((result: any) => {
                this.savedInformationSets = result.data.map((info: any) => {
                    return { value: info._id, label: info.information };
                });
            });
        },
        async getAllTeams() {
            await this.$http.get(`${process.env.VUE_APP_ORG_API}/departments/get`).then((res: any) => {
                for (var i = 0; i < res.data.length; i++) {
                    let a = {value:res.data[i]._id, label:res.data[i].displayName}
                    this.departmentList.push(a);
                }
            });
        },
        async getBusinessProcess() {
            this.businessProcessList = [];
            this.tableRow = [];

            try {
                const result = await this.$http.get(`${process.env.VUE_APP_ORG_API}/api/org/getall/${20006}`);
                // this.$store.dispatch('updateDotsLoading',true);
                console.table(result.data);
                result.data.forEach((entity:any) => {
                    const mainName = this.optionsUserArray.find((obj: any) => { 
                        return obj.value === entity.name
                    });
                    const mainDept = this.departmentList.find((obj: any) => {
                        return obj.value === entity.department
                    });
                    
                    // const entity =this.
                    const owner = mainName ? mainName.label : 'N/A';
                    const department = mainDept ? mainDept.label : 'N/A';

                    this.tableRow.push({
                        _id: entity._id,
                        entityId: 20006,
                        'Activity': entity.businessProcessName,
                        'Location':entity.entity? this.Entities.find((e:any)=>e.value==entity.entity)?.label:'N/A' ,
                        'criticality': entity.criticality ? entity.criticality: 'N/A',
                        Owner: owner,
                        Team: department,
                        'Owner Type': entity.ownerType,
                        'risks':entity.riskCount && entity.riskCount ? entity.riskCount : '0',
                        Email: entity.emailAddress,
                        Phone: entity.phoneNumber,
                        description:entity.description,
                    });
                    
                    if (entity.ownerType === 1) {
                        this.thirdPartyPrimaryCondition = true;
                    }
                });
                // this.$store.dispatch('updateDotsLoading',false);
            } catch (error) {
                // this.$store.dispatch('updateDotsLoading',false);
                console.error('Error fetching business processes:', error);
            }
        },
    },
    async mounted(){
        emitter.off('activiteToolTip');
        emitter.on('activiteToolTip', (data: any) => {
            this.toolTipActive = true;
            this.toolTipText = data.tipText
        });
 
        emitter.off('deActiviteToolTip');
        emitter.on('deActiviteToolTip', (data: any) => {
            this.toolTipActive = false;
            this.toolTipText = ''
        });
    },
    async created() {
        this.dataLoading = true;

        await this.getAllUsers();
        await this.getAllTenants();
        await this.getSystems();
        await this.getInformationSets();
        await this.getAllTeams();
        await this.getSingleEntity();
        await this.getBusinessProcess();
        
        this.dataLoading = false;
    }
});
</script>
